// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3690":"781322c5","3931":"d2cd06ed","4163":"3885be0f","7773":"3885be0f","8777":"fe58350d"}[chunkId] + ".chunk.css";
};